import { COLUMN_SIZE } from 'components/common/DataGridDevEx/DataGrid.constants';

export const columns = [
    {
        dataField: 'Entity',
        caption: 'Entity',
        minWidth: COLUMN_SIZE.md0,
        width: COLUMN_SIZE.md1,
        alignment: 'left'
    },
    {
        dataField: 'CustomerIdDisplay',
        caption: 'Customer',
        minWidth: COLUMN_SIZE.md0,
        width: COLUMN_SIZE.md1
    },
    {
        dataField: 'CustomerName',
        caption: 'Name',
        minWidth: COLUMN_SIZE.md0,
        width: COLUMN_SIZE.md1
    },
    {
        dataField: 'Username',
        caption: 'Username',
        minWidth: COLUMN_SIZE.md0,
        width: COLUMN_SIZE.md1
    },
    {
        dataField: 'EnteredDate',
        caption: 'Entered',
        minWidth: COLUMN_SIZE.md0,
        width: COLUMN_SIZE.md0
    },
    {
        dataField: 'EnteredTime',
        caption: 'Time',
        minWidth: COLUMN_SIZE.sm1,
        width: COLUMN_SIZE.sm1
    },
    {
        dataField: 'Notes',
        caption: 'Notes',
        minWidth: COLUMN_SIZE.xl0,
        width: COLUMN_SIZE.xl0
    },
    {
        dataField: 'WorkCreditNoteId',
        caption: 'WorkCreditNoteId',
        visible: false
    },
];
